module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesLuxury@2x.e919d9e.webp";